import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL + '/api/tunjangan';

export const getTunjangans = (params) =>
  axios.get(BASE_URL, { params });

export const getTunjangan = (id) =>
  axios.get(`${BASE_URL}/${id}`);

export const createTunjangan = (data) =>
  axios.post(BASE_URL, data);

export const updateTunjangan = (id, data) =>
  axios.put(`${BASE_URL}/${id}`, data);

export const deleteTunjangan = (id) =>
  axios.delete(`${BASE_URL}/${id}`);

export const dropdownTunjangan =  () => 
  axios.get(`${BASE_URL}/drop/down`);
